import { render } from "./Home.vue?vue&type=template&id=195b1602&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=195b1602&scoped=true&lang=css"
import "./Home.vue?vue&type=style&index=1&id=195b1602&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195b1602"]])

export default __exports__